// Form
// ====

import './app';
import Form from './Components/Form';

window.Form = Form;
document.addEventListener('DOMContentLoaded', (e) => {
    const form = new Form('#ContactRequestForm', '#ContactRequestSubmitButton');
    document.dispatchEvent(new CustomEvent('CtaInitialized', { cancelable: false, detail: form }));
});
